import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Modal } from "semantic-ui-react";
import { ModalHeader, Textlink, StyledModal } from "../common/StyledComponents";

const DeleteUserModal = (props) => {
  // console.log(props);
  const [open, setOpen] = useState(props.open);
  const deleteUser = (bool) => {
    setOpen(false);
    props.deleteUser(bool);
  };

  return (
    <StyledModal
      onClose={() => deleteUser(false)}
      onOpen={() => setOpen(true)}
      open={open}
      size="mini"
      style={{ position: "relative" }}
    >
      <ModalHeader regular>Delete this user?</ModalHeader>
      <Modal.Content>
        <p>This cannot be undone, are you sure you want to delete this user?</p>
      </Modal.Content>
      <Modal.Actions>
        <Textlink role="button" onClick={() => deleteUser(false)}>
          No, I want to keep this
        </Textlink>
        <Button negative onClick={() => deleteUser(true)}>
          Delete
        </Button>
      </Modal.Actions>
    </StyledModal>
  );
};

DeleteUserModal.propTypes = {};

DeleteUserModal.defaultProps = {};

export default DeleteUserModal;
